export const onInitialClientRender = () => {
  document.addEventListener('mouseup', e => {
    if (!e.target.closest('#navbar')) {
      document.getElementById('mobile-menu-button').classList.remove('open');
      document.getElementById('navbar').classList.remove('show');
    }
  });
}